/**
 * Conflict check — used by the calendar before committing a reschedule
 * or a new-class create.
 */

import { useMutation } from '@tanstack/react-query';

import { api } from '@core/api/client';
import type { components } from '@api/index';

export type ConflictCheckRequest = components['schemas']['ConflictCheckRequest'];
export type ConflictCheckResponse = components['schemas']['ConflictCheckResponse'];
export type ConflictItem = components['schemas']['ConflictItem'];

export async function checkConflicts(body: ConflictCheckRequest): Promise<ConflictCheckResponse> {
  return api.post<ConflictCheckResponse>('/v1/calendar/conflicts/check', body);
}

export function useCheckConflicts() {
  return useMutation({
    mutationFn: checkConflicts,
  });
}

